<template>
<div>
  <vue-headful
    :title=contentPage.metaTitle
    :description=contentPage.metaDescription
    :keywords=contentPage.metaKeywords
  />
  <top-navigation></top-navigation>
  <div>
    <div class="container">
      <div class="row">
        <left-sidebar :showProductCategoryNavigation=true></left-sidebar>
        <div class="col-sm-9 padding-right content-page">
          <h2>{{ contentPage.pageTitle }}</h2>
          <div v-html="contentPage.pageText"/>
          <br/><br/>
          <p><a target="_new" :href="eBayUrl" class="btn btn-default">Visit our eBay Shop</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import LeftSidebar from '../components/common/LeftSidebar';
import ProductGroups from '../components/products/ProductGroups';
import TopNavigation from '../components/common/TopNavigation';
import { EBAY_SHOP_URL } from '../config';

export default {
  name: 'home',
  created() {
    if (this.contentPage.length === 0 || this.currentPage !== this.contentSlug) {
      this.$store.dispatch('getHomepageContent');
    }
  },
  data() {
    return {
      eBayUrl: EBAY_SHOP_URL,
    };
  },
  watch: {
    /* eslint no-unused-vars: [2, { "args": "none" }] */
    $route(to, from) {
      if (this.currentPage !== this.contentSlug) {
        this.$store.dispatch('getHomepageContent');
      }
    },
  },
  computed: {
    contentSlug() {
      return this.$route.params.contentSlug;
    },
    contentPage() {
      return this.$store.getters.getHomepageContent;
    },
    currentPage() {
      return this.$store.getters.getCurrentPage;
    },
  },
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
    'product-groups': ProductGroups,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue